export const SET_SITESETTINGS_CURRENTLANGUAGE = 'SET_SITESETTINGS_CURRENTLANGUAGE'
export const SET_SITESETTINGS_AVAILABLELANGUAGES = 'SET_SITESETTINGS_AVAILABLELANGUAGES'
export const SET_SITESETTINGS_SITENAME = 'SET_SITESETTINGS_SITENAME'
export const SET_SITESETTINGS_LOGOUTURL = 'SET_SITESETTINGS_LOGOUTURL'
export const SET_DICTIONARY = 'SET_DICTIONARY'
